import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import getLongFormApi from '../../../api/services/getLongFormApi.service';

const initialState = {
  value: [],
};

export const getLongFormCall = createAsyncThunk(
  'getLongFormCall',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getLongFormApi.getLongForm();
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);

const getLongForm = createSlice({
  name: 'getLongForm',
  initialState,
  reducers: {
    savingValue: (state, action) => {
      state.value = { ...action.payload };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getLongFormCall.pending, () => {})
      .addCase(getLongFormCall.fulfilled, (state: any, action) => {
        state.value = action.payload;
      })
      .addCase(getLongFormCall.rejected, () => {});
  },
});

export const { savingValue } = getLongForm.actions;

export default getLongForm.reducer;
